/*!
 * RBF Cosmetics — Cart Drawer Micro-Interactions
 * ------------------------------------------------------------------
 * Purely additive GSAP polish on top of the existing, working cart
 * JS (theme.js's GspCartDrawerItems/CartDrawer custom elements). This
 * module does not intercept or replace any cart logic — it only
 * listens to the SAME "cart-update" event those custom elements
 * already emit via window.gspEvents (confirmed present in theme.js),
 * and layers a subtle reveal/pulse on top of the DOM they've already
 * updated.
 *
 * Why not animate individual item removal directly: the existing
 * quantity-to-zero removal flow re-fetches and replaces the entire
 * [data-gsp-cart-items] container's innerHTML as soon as the request
 * resolves, rather than removing a single DOM node in place — so a
 * "this one item fades out" animation would be racing against (and
 * likely cut short by) that replacement. Animating the freshly
 * rendered container as a whole, once per cart-update event, is the
 * safe, real place to add motion without fighting that timing.
 *
 * Loaded as a classic deferred script (see snippets/rbf-scripts.liquid)
 * alongside rbf-motion.js — reads the same window.rbfMotion API.
 * No-ops entirely if window.gspEvents or window.rbfMotion aren't
 * present, so the cart remains fully functional either way.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  function init() {
    if (typeof window.gspEvents === 'undefined' || typeof window.gspEvents.subscribe !== 'function') {
      return;
    }

    window.gspEvents.subscribe('cart-update', function () {
      var itemsContainer = document.querySelector('[data-gsp-cart-items]');
      var subtotalValue = document.querySelector('[data-cart-subtotal] .totals__total-value');

      if (itemsContainer && window.rbfMotion) {
        window.rbfMotion.fadeIn(itemsContainer, { duration: window.rbfMotion.durations.base });
      }

      if (subtotalValue && window.gsap && window.rbfMotion && !window.rbfMotion.prefersReducedMotion()) {
        window.gsap.fromTo(
          subtotalValue,
          { scale: 1.08 },
          { scale: 1, duration: window.rbfMotion.durations.moderate, ease: 'power2.out' }
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
